/** @module ProductSpec/NewMaterialBOMController */
define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/table/New",
	"csi/xml"
], function(declare,reflection,New,xml) {

	return declare(New, {
		/**
		 * @override
		 * Add MaterialBOMSubtype and BOMProductColors to the server operation and consume the values
		 * so they don't also get processed as ChangeAttributes by the framework
		 */
		toWriterRequest: function() {
			var	fd = this.getFormData();
			var call = this.inherited(arguments);
			call.addParameter("Subtype", xml.ATTR_REF, fd.getFieldValue(reflection.ATTR_SUBTYPE, true));
			call.addParameter("BOMProductColors", xml.ATTR_REFLIST, fd.getFieldValue("BOMProductColors", true));
			return call;
		}
	});
});